<template>
  <div class="homeBox">
    <!-- 头部 -->
    <div class="title-top">
      <p class="title-mune" @click="leftMenu = true"></p>
      <span>智慧服务开放平台</span>
    </div>
    <!-- 左侧菜单 -->
    <van-popup
        v-model="leftMenu"
        position="left"
        :style="{ width: '70%', height: '100%' }"
    >
      <div class="swiper-slide menu swiper-slide-prev" style="background: #fff">
        <p class="left-title"></p>
        <div style="padding-left: 1.1rem">
          <p class="menu-title">
            <i class="file"></i>
            <span>
              <a href="https://doc.quickapp.cn/">开发文档</a>
            </span>
          </p>
<!--          <p-->
          <!--              class="menu-title"-->
          <!--              @click="-->
          <!--              _hmt.push(['_trackEvent', '流量扶持计划-手机端', '表格下载'])-->
          <!--            "-->
          <!--          >-->
          <!--            <i class="speak"></i>-->
          <!--            <span>-->
          <!--              <a href="https://bbs.aiservhub.com/m/">论坛</a>-->
          <!--            </span>-->
          <!--          </p>-->
          <p
              class="menu-title callusbtn"
              @click="
              leftMenu = false;
              goToSixthPage();
            "
          >
            <i class="phone"></i>
            <span>联系我们</span>
          </p>
        </div>
      </div>
    </van-popup>
    <div class="jump-top" @click="up"></div>
    <!-- 主体 -->
    <swiper :options="swiperOption" class="swiperBox" ref="mySwiper">
      <swiper-slide class="swiper-slide full-screen first-page">
        <p class="one fadeIn">
          <span>赋能开发者 拓展场景未来</span>
        </p>
        <p class="two fadeIn">
          <i class="radius"></i>
          <span>标准化接入智慧服务生态</span>
        </p>
        <div style="margin-left: -20px">
          <div class="top-blue1">
            <p class="top-blue"></p>
          </div>
          <div class="top-pink1">
            <p class="top-pink"></p>
          </div>
          <div class="bottom-pink1">
            <p class="bottom-pink"></p>
          </div>
          <div class="bottom-blue1">
            <p class="bottom-blue"></p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide
          class="swiper-slide full-screen first-page"
          v-for="item in flowSupportList"
          :key="item.id"
          tag="div"
      >
        <a
            class="flowSupportBox"
            :style="{ 'background-image': 'url(' + item['banner'] + ')' }"
            :href="item.url ? item.url : 'javascript:;'"
        >
          <div class="quickAppBox" v-if="item.rpkList.length > 0">
            <dl class="dl" v-for="item2 of item.rpkList" :key="item2.uuid">
              <dt class="dt">
                <img
                    width="100%"
                    class="activityIcon"
                    :src="item2.icon"
                    alt=""
                />
              </dt>
              <dd class="dd">{{ item2.name }}</dd>
            </dl>
          </div>
        </a>
      </swiper-slide>
      <!--      <swiper-slide class="swiper-slide full-screen">-->
      <!--        <div class="flowSupportIntroduceBox" @click="flowSupportApply"></div>-->
      <!--      </swiper-slide>-->
      <swiper-slide class="swiper-slide full-screen" v-if="awardsAct.status">
        <router-link
            class="awardsActBox"
            to="/active/awardsAct4"
            tag="div"
        ></router-link>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen secend-page">
        <p class="one fadeIn">
          <span>快应用</span>
          <i class="twopage-title"></i>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>即点即用：快应用革命性应用形态，无需下载等待，即点即用，易推广、高留存。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>海量设备：国内主流品牌手机均已支持快应用的框架能力，生态覆盖了15亿+用户。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>多端设备：快应用生态支持多端设备，手机、手表、大屏、车机、音箱等iOT设备，可以覆盖用户全场景服务。</span>
        </p>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen secend-page">
        <p class="one fadeIn">
          <span>智慧卡片</span>
          <i class="twopage-title"></i>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>智能推荐：通过精准智慧分发，实时推送用户感兴趣的卡片内容，高效触达、体验随心。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>服务直达：在系统浅层入口直接展示应用的关键信息，减少操作层级，实现快速访问和高效服务。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>情景感知：根据用户的场景和行为习惯，动态调整卡片内容，提供个性化的智能服务，增强用户体验的贴合度。</span>
        </p>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen secend-page">
        <p class="one fadeIn">
          <span>智能体</span>
          <i class="twopage-title"></i>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>智能助理：基于AI大模型打造更懂用户意图的分发模式，精准高效为用户提供服务。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>系统自主学习：理解用户习惯和偏好，一句话完成订餐、订票、导航等复杂任务。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>打造AI新生态：手机智能助手及智能体广场作为AI时代的新流量入口，一站式满足用户智能需求。</span>
        </p>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen secend-page">
        <p class="one fadeIn">
          <span>快游戏</span>
          <i class="twopage-title"></i>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>堪比APP的游戏性能：系统级生态技术方案确保快游戏优质体验。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>国内主流游戏引擎支持：主流Cocos、Laya等引擎已支持快游戏。</span>
        </p>
        <p class="two fadeIn">
          <i class="circular-point"></i>
          <span>触达超过10亿的海量用户：国内主流品牌手机已支持快应用框架。</span>
        </p>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen third-page">
        <p class="title fadeIn">
          <span>接入流程</span>
          <i></i>
        </p>
        <p class="content fadeIn">① 平台入驻：了解智慧服务的入驻流程、异常问题的处理方法</p>
        <p class="content fadeIn">② 选择业务生态：根据您的实际需要，全面了解并选择最适合接入的产品生态体系</p>
        <p class="content fadeIn">③ 开发调试：从开发、接口、配置、调试等维度，了解智慧服务接入步骤</p>
        <p class="content fadeIn">④ 发布经营：了解智慧服务的审核上架规范，您可以根据规范自查</p>
      </swiper-slide>
      <!--      <swiper-slide class="swiper-slide full-screen forth-page">-->
      <!--        <p class="title fadeIn">-->
      <!--          <span>开发支持</span>-->
      <!--          <i></i>-->
      <!--        </p>-->
      <!--        <p class="content-title fadeIn">-->
      <!--          <i class="circular-point"></i>-->
      <!--          <span>开发教程</span>-->
      <!--        </p>-->
      <!--        <p class="content fadeIn">-->
      <!--          <span-->
      <!--          >教程分为总览、使用IDE、框架、组件、接口、平台和其他七部分，帮助开发者快速了解快应用研发...</span-->
      <!--          >-->
      <!--          <a href="https://doc.aiservhub.com/">查看更多</a>-->
      <!--        </p>-->
      <!--        <p class="content-title fadeIn">-->
      <!--          <i class="circular-point"></i>-->
      <!--          <span>开发者工具</span>-->
      <!--        </p>-->
      <!--        <p class="content fadeIn">-->
      <!--          <span-->
      <!--          >为了方便开发，提供了-->
      <!--            IDE（快应用开发工具）来帮助开发者完成工程的创建、调试、打包等工作...</span-->
      <!--          >-->
      <!--          <a href="https://doc.aiservhub.com/tutorial/ide/overview.html"-->
      <!--          >查看更多</a-->
      <!--          >-->
      <!--        </p>-->
      <!--        <p class="content-title fadeIn">-->
      <!--          <i class="circular-point"></i>-->
      <!--          <span>快应用框架</span>-->
      <!--        </p>-->
      <!--        <p class="content fadeIn">-->
      <!--          <span-->
      <!--          >以前端开发技术栈为主进行应用开发的框架，采用流行的前端开发模式，贴合主流前端开发者的思维习惯...</span-->
      <!--          >-->
      <!--          <a href="https://doc.aiservhub.com/framework/">查看更多</a>-->
      <!--        </p>-->
      <!--      </swiper-slide>-->
      <swiper-slide class="swiper-slide full-screen fifth-page">
        <p class="title">
          <span>联盟成员</span>
          <i></i>
        </p>
        <div class="content">
          <ul>
            <li v-for="(item, index) of memberList" :key="index">
              <img :src="item.logo" alt=""/>
            </li>
          </ul>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide full-screen sixth-page">
        <p class="title fadeIn">
          <span>联盟服务方</span>
          <i></i>
        </p>
        <!--        <p class="content fadeIn">-->
        <!--          <i class="phone"></i>-->
        <!--          <span>电话：010-86461812转8187</span>-->
        <!--        </p>-->
        <p class="content fadeIn">
          <i class="mail" style="margin-top: -2px"></i>
          <span>邮箱：yunying@quickapp.cn</span>
        </p>
        <p class="content fadeIn">
          <i class="mail" style="margin-top: -2px"></i>
          <span>快应用客服微信号：kuaiyingyongguanKF</span>
        </p>
        <p class="content fadeIn">
          <i class="mail" style="margin-top: -2px"></i>
          <span>快游戏客服微信号：kuaiyouxiGFKF</span>
        </p>
        <p class="erweima fadeIn"></p>
<!--        <a href="https://bbs.aiservhub.com/m/" class="fadeIn"-->
<!--        ><p class="joinBBS"></p-->
<!--        ></a>-->
        <p class="checkoutPC fadeIn" @click="goPC"></p>
        <p class="goback fadeIn" @click="goTop">回到顶部</p>
      </swiper-slide>
    </swiper>
    <!--联系我们弹框-->
    <div class="callusBox" v-if="weBox">
      <div class="callus">
        <div class="callus-titletop"></div>
        <div class="gobackbtn" @click="weBox = false"></div>
        <div class="memberBox">
          <div class="LOL">
            <div class="callusTitle"><i></i><span>联盟服务方</span></div>
            <!--            <p><i class="phone"></i><span>电话：010-86461812转8187</span></p>-->
            <p><i class="mail"></i><span>邮箱：yunying@quickapp.cn</span></p>
            <p style="width: 100%;"><i class="mail"></i><span>快应用客服微信号：kuaiyingyongguanKF</span></p>
            <p style="width: 100%;"><i class="mail"></i><span>快游戏客服微信号：kuaiyouxiGFKF</span></p>
          </div>
          <div
              class="lianxiang"
              v-for="(item, index) of memberList"
              :key="index"
          >
            <div class="callusTitle">
              <i></i><span>{{ item.name }}</span>
            </div>
            <!--            <p><i class="phone"></i><span>电话：{{item.contact}}</span></p>-->
            <p>
              <i class="mail"></i><span>邮箱：{{ item.email }}</span>
            </p>
            <p>
              <i class="address"></i><span>地址：{{ item.address }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/css/home.css";
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import $ from "jquery";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  created() {
    this._hmt = window._hmt; //百度埋点
    this.queryFlowSupportList(); //获取风运营支持计划活动 ID
  },
  mounted() {
    this.queryAwardsActDetail(); //获取风锐奖活动
    this.queryMemberContactList(); //获取厂商联系人
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      leftMenu: false, //左侧菜单
      weBox: false, //联系我们弹框
      //滑块
      isInit: false, //联系我们弹框
      swiperOption: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange(Swiper) {
            if (this.activeIndex == $(".swiperBox .swiper-slide").length - 1) {
              $(".jump-top").hide();
            } else {
              $(".jump-top").show();
            }
          },
        },
      },
      flowSupportList: [], //运营支持计划list[id,id]
      awardsAct: {}, //风锐奖活动
      memberList: [], //厂商list
    };
  },
  methods: {
    //往上滑
    up() {
      if (this.swiper.activeIndex >= 0) {
        this.swiper.slideTo(this.swiper.activeIndex + 1, 400, false);
      }
    },
    //去PC
    goPC() {
      if (window.location.host == "m.aiservhub.com" || window.location.host == "m.quickapp.cn") {
        window.location.href = "https://www.aiservhub.com/";
      } else {
        var hostAry = window.location.host.split(".");
        hostAry.splice(1, 1);
        window.location.href =
            window.location.protocol + "//" + hostAry.join(".");
      }
    },
    //回到顶部
    goTop() {
      this.swiper.slideTo(0, 400, false);
    },
    //厂商list
    queryMemberContactList() {
      this.$apis.homeServer.queryMemberContactList().then((res) => {
        if (res["code"] == 0) {
          this.memberList = res.data.dataList.filter(
              (item) => item.rpkType == 1
          ); //过滤手机组的厂商
        } else {
          this.$dialog.alert({
            message: data["msg"],
          });
        }
      });
    },
    //获取运营支持计划活动List
    queryFlowSupportList() {
      this.$apis.homeServer.queryFlowSupportList().then((res) => {
        if (res["code"] == 0 && res.data) {
          this.flowSupportList = res.data.dataList;
        } else {
          this.$dialog.alert({
            message: data["msg"],
          });
        }
      });
    },
    //运营支持活动报名 请使用电脑访问快应用官网报名
    flowSupportApply() {
      this.$toast("请使用电脑访问快应用官网报名");
    },
    //获取风锐奖活动
    queryAwardsActDetail() {
      this.$apis.awardsActServer
          .queryAwardsActDetail({
            id: "2",
          })
          .then((res) => {
            if (res["code"] == 0) {
              this.awardsAct = res.data;
            } else {
              this.$dialog.alert({
                message: data["msg"],
              });
            }
          });
    },
    //滑动到第六页（联系我们页面）
    goToSixthPage() {
      this.swiper.slideTo(8, 400, false);
    },
  },
};
</script>
<style lang="scss" scoped>
.homeBox {
  p {
    line-height: 1.5;
  }

  .title-top {
    width: 100%;
    height: 110px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#fff, 1);

    .title-mune {
      position: absolute;
      left: 50px;
      top: 20px;
      width: 70px;
      height: 70px;
      background: url("~@/assets/img/home/new.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .jump-top {
    position: absolute;
    bottom: 0.4rem;
    left: 50%;
    margin-left: -0.57rem;
    width: 1.14rem;
    height: 0.58rem;
    z-index: 9;
    background: url("~@/assets/img/home/jump.png") no-repeat;
    background-size: 100% 100%;
    animation: myjump 1.5s infinite;
  }

  .swiperBox {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .swiper-slide {
      .first-page {
        position: relative;
        background: url("~@/assets/img/home/pageoneBG.jpg") no-repeat;
        background-size: 100%;
      }

      .b {
        width: 100%;
        height: 100%;
        background: yellow;
      }

      .awardsActBox {
        position: relative;
        width: 100%;
        height: 100%;
        background: url("~@/assets/img/home/bannerAwardsAct4.jpg") no-repeat top center;
        background-size: 100%;
      }

      .flowSupportBox {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;

        .quickAppBox {
          position: absolute;
          left: 50%;
          top: 58%;
          width: 100%;
          transform: translate(-50%, -50%);
          display: flex;
          flex-wrap: wrap;
          justify-content: center;

          .dl {
            margin-bottom: 0.7rem;
            width: 3rem;
            text-align: center;

            .dt {
              .activityIcon {
                border-radius: 0.4rem;
                margin-bottom: 0.2rem;
                width: 2rem;
                height: 2rem;
              }
            }

            .dd {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
            }
          }
        }
      }
    }

    .flowSupportIntroduceBox {
      position: relative;
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/home/flowSupportIntroduceBox.png") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
